import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bf90492"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "discount-code-page" }
const _hoisted_2 = { class: "discount-code-page__header" }
const _hoisted_3 = { class: "discount-code-page__card-title" }

import { SIZES, FORMATS } from '@/enums/components'
import { ROUTE_PATHS } from '@/router/paths'
import FormNewDiscountCode from '@/components/discount-codes/FormNewDiscountCode.vue'
import BaseButton from '@/components/BaseButton.vue'
import BaseCard from '@/components/BaseCard.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewDiscountCodeView',
  setup(__props) {

const route = useRoute()
const isEditMode = computed(() => !!route.params.uuid)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseButton, {
        format: _unref(FORMATS).TERTIARY,
        size: _unref(SIZES).SMALL,
        icon: "arrow-left",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: _unref(ROUTE_PATHS).DISCOUNT_CODES })))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('discountCodes.seeAllDiscountCodes')), 1)
        ]),
        _: 1
      }, 8, ["format", "size"])
    ]),
    _createVNode(BaseCard, { small: "" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_unref(isEditMode)
              ? _ctx.$t('discountCodes.editDiscountCode')
              : _ctx.$t('discountCodes.addNewDiscountCode')), 1)
        ])
      ]),
      body: _withCtx(() => [
        _createVNode(FormNewDiscountCode)
      ]),
      _: 1
    })
  ]))
}
}

})